import ticketDetails from '../localization-messages/ticketDetails/sv-SE.json';
import ticketCancelForm from '../localization-messages/ticketCancelForm/sv-SE.json';
import ticketListing from '../localization-messages/ticketListing/sv-SE.json';
import ticketForm from '../localization-messages/ticketForm/sv-SE.json';
import headerFooter from '../localization-messages/headerFooter/sv-SE.json';
import reconfirmUserDetailsModal from '../localization-messages/reconfirmUserDetailsModal/sv-SE.json';
import termsModal from '../localization-messages/termsModal/sv-SE.json';

export const svSETranslations = {
  ticketDetails,
  ticketCancelForm,
  ticketListing,
  ticketForm,
  headerFooter,
  reconfirmUserDetailsModal,
  termsModal,
};
